import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from 'features/new-actor/enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import {
  BorrowerInsuredFormFieldNames,
  BorrowerLegalFormValues
} from '../borrowerInsuredForm';
import { borrowerLegalEntityValidationRules } from './borrowerLegal.validation';

export const borrowerLegalFormConfig =
  createFormConfig<BorrowerLegalFormValues>(
    borrowerLegalEntityValidationRules as ValidationRules<
      keyof BorrowerLegalFormValues
    >,
    {
      [BorrowerInsuredFormFieldNames.BorrowerId]: undefined,
      [PersonalInformationFieldNames.Civility]: 'Mr',
      [AddressFormFieldNames.Country]: 'FR',
      [PersonalInformationFieldNames.Nationality]: 'FR',
      [PersonalInformationFieldNames.BirthCountry]: 'FR',
      [NaturalPersonFormFieldNames.TaxResidenceCountryId]: 'FR',
      [BorrowerInsuredFormFieldNames.ProspectType]: 'borrower'
    }
  );
